import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';

const css = oxygenCss({
  root: {
    boxSizing: 'border-box',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: 28,
    borderColor: 'transparent',
    display: 'inline-block'
  },
  icon: {
    verticalAlign: 'middle'
  }
});

class Gift extends Component {
  static propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    fill: PropTypes.string,
    borderColor: PropTypes.string
  };

  static defaultProps = {
    color: '#7E7E7E',
    fill: 'transparent',
    borderColor: '#7E7E7E'
  };

  render() {
    const { className, color, fill, borderColor, ...other } = this.props;
    return (
      <svg
        style={{ backgroundColor: fill, borderColor }}
        {...other}
        xmlns="http://www.w3.org/2000/svg"
        width="169"
        height="28"
        viewBox="0 0 169 28"
        version="1.1"
        className={classNames(className, css.root, css.icon)}
      >
        <defs>
          <polygon
            id="path-1"
            points="0 12.6731378 70.4771076 12.6731378 70.4771076 3.16049384e-05 0 3.16049384e-05"
          />
          <rect id="path-3" x="0" y="0" width="169" height="28" rx="14" />
          <mask
            id="mask-4"
            maskContentUnits="userSpaceOnUse"
            maskUnits="objectBoundingBox"
            x="0"
            y="0"
            width="169"
            height="28"
            fill="white"
          >
            <use href="url(#path-3" />
          </mask>
        </defs>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-96.000000, -85.000000)">
            <g transform="translate(96.000000, 85.000000)">
              <path
                d="M15.243,17.6 L16.541,17.6 L16.541,14.74 L18.323,14.74 C19.94,14.74 20.941,13.827 20.941,12.331 C20.941,10.802 19.852,9.9 18.312,9.9 L15.243,9.9 L15.243,17.6 Z M16.541,13.541 L16.541,11.099 L18.279,11.099 C18.95,11.099 19.61,11.418 19.61,12.331 C19.61,13.112 19.016,13.541 18.29,13.541 L16.541,13.541 Z M24.277,16.632 C23.419,16.632 22.814,15.983 22.814,14.685 C22.814,13.398 23.43,12.738 24.277,12.738 C25.124,12.738 25.729,13.42 25.729,14.685 C25.729,15.95 25.124,16.632 24.277,16.632 Z M24.277,17.765 C25.784,17.765 26.961,16.676 26.961,14.685 C26.961,12.694 25.707,11.605 24.277,11.605 C22.836,11.605 21.571,12.694 21.571,14.685 C21.571,16.676 22.759,17.765 24.277,17.765 Z M29.153,17.6 L30.352,17.6 L31.881,13.222 L31.903,13.222 L33.322,17.6 L34.532,17.6 L35.929,11.77 L34.719,11.77 L33.784,15.818 L33.762,15.818 L32.464,11.77 L31.331,11.77 L29.945,15.829 L29.923,15.829 L29.098,11.77 L27.866,11.77 L29.153,17.6 Z M40.981,15.664 C40.728,16.06 40.332,16.654 39.441,16.654 C38.517,16.654 38.022,16.005 37.989,15.059 L42.059,15.059 L42.059,14.685 C42.059,12.771 40.926,11.605 39.408,11.605 C37.879,11.605 36.724,12.793 36.724,14.685 C36.724,16.577 37.879,17.765 39.463,17.765 C40.695,17.765 41.432,17.127 41.883,16.401 L40.981,15.664 Z M38,14.113 C38.044,13.442 38.506,12.716 39.408,12.716 C40.343,12.716 40.794,13.332 40.838,14.113 L38,14.113 Z M43.404,17.6 L44.658,17.6 L44.658,14.355 C44.658,13.343 45.021,12.903 45.681,12.903 C45.879,12.903 46.022,12.958 46.143,12.991 L46.341,11.77 C46.209,11.715 46.033,11.66 45.824,11.66 C45.329,11.66 44.845,11.935 44.614,12.386 L44.592,12.386 L44.592,11.77 L43.404,11.77 L43.404,17.6 Z M51.338,15.664 C51.085,16.06 50.689,16.654 49.798,16.654 C48.874,16.654 48.379,16.005 48.346,15.059 L52.416,15.059 L52.416,14.685 C52.416,12.771 51.283,11.605 49.765,11.605 C48.236,11.605 47.081,12.793 47.081,14.685 C47.081,16.577 48.236,17.765 49.82,17.765 C51.052,17.765 51.789,17.127 52.24,16.401 L51.338,15.664 Z M48.357,14.113 C48.401,13.442 48.863,12.716 49.765,12.716 C50.7,12.716 51.151,13.332 51.195,14.113 L48.357,14.113 Z M57.435,15.367 C57.435,16.038 56.929,16.632 56.104,16.632 C55.169,16.632 54.63,15.961 54.63,14.685 C54.63,13.409 55.169,12.738 56.104,12.738 C56.962,12.738 57.435,13.376 57.435,14.047 L57.435,15.367 Z M57.523,17.6 L58.689,17.6 L58.689,9.57 L57.435,9.57 L57.435,12.331 L57.413,12.331 C57.314,12.21 56.852,11.605 55.895,11.605 C54.586,11.605 53.376,12.727 53.376,14.685 C53.376,16.555 54.366,17.765 55.906,17.765 C56.907,17.765 57.424,17.138 57.501,17.039 L57.523,17.039 L57.523,17.6 Z M64.503,14.047 C64.503,13.376 64.987,12.738 65.845,12.738 C66.769,12.738 67.308,13.409 67.308,14.685 C67.308,15.961 66.769,16.632 65.845,16.632 C65.009,16.632 64.503,16.038 64.503,15.367 L64.503,14.047 Z M63.249,17.6 L64.415,17.6 L64.415,17.039 L64.437,17.039 C64.525,17.138 65.031,17.765 66.032,17.765 C67.572,17.765 68.562,16.555 68.562,14.685 C68.562,12.815 67.484,11.605 66.054,11.605 C65.119,11.605 64.624,12.21 64.525,12.331 L64.503,12.331 L64.503,9.57 L63.249,9.57 L63.249,17.6 Z M70.358,20.075 L71.568,20.075 L74.89,11.77 L73.592,11.77 L72.063,15.785 L72.041,15.785 L70.512,11.77 L69.192,11.77 L71.458,17.336 L70.358,20.075 Z"
                fill={color}
              />
              <g transform="translate(86.502370, 8.000000)">
                <path
                  d="M17.0976754,6.32808296 C17.0976754,3.93400889 18.759047,2.09238914 21.2256431,2.09238914 C22.7324686,2.09238914 23.6232108,2.69509531 24.2572382,3.49896691 L23.4007677,4.25211259 C22.8525814,3.51555951 22.1504954,3.21452247 21.294025,3.21452247 C19.5471356,3.21452247 18.4336271,4.53671506 18.4336271,6.32808296 C18.4336271,8.11992494 19.5471356,9.4591842 21.294025,9.4591842 C22.1504954,9.4591842 22.8525814,9.12417185 23.4007677,8.40468543 L24.2572382,9.17489778 C23.6232108,9.97845333 22.7324686,10.5813175 21.2256431,10.5813175 C18.759047,10.5813175 17.0976754,8.72215704 17.0976754,6.32808296 L17.0976754,6.32808296 Z"
                  fill={color}
                />
                <path
                  d="M32.425619,6.32808296 C32.425619,4.68747062 31.4490358,3.21452247 29.6853339,3.21452247 C27.9209853,3.21452247 26.9448871,4.68747062 26.9448871,6.32808296 C26.9448871,7.98623605 27.9209853,9.4591842 29.6853339,9.4591842 C31.4490358,9.4591842 32.425619,7.98623605 32.425619,6.32808296 M25.5914762,6.32808296 C25.5914762,3.98426074 27.1673301,2.09238914 29.6853339,2.09238914 C32.2028526,2.09238914 33.7785449,3.98426074 33.7785449,6.32808296 C33.7785449,8.67222123 32.2028526,10.5813175 29.6853339,10.5813175 C27.1673301,10.5813175 25.5914762,8.67222123 25.5914762,6.32808296"
                  fill={color}
                />
                <path
                  d="M41.4501147,10.3803891 L41.4501147,9.24182123 C40.8164106,9.94471506 39.7374971,10.5812385 38.5038757,10.5812385 C36.7744456,10.5812385 35.8668908,9.7440237 35.8668908,8.00211753 L35.8668908,2.29347556 L37.1511115,2.29347556 L37.1511115,7.61764346 C37.1511115,9.04112988 37.8876308,9.45926321 39.017952,9.45926321 C40.0116711,9.45926321 40.9707951,8.89005827 41.4501147,8.23710025 L41.4501147,2.29347556 L42.734497,2.29347556 L42.734497,10.3803891 L41.4501147,10.3803891 Z"
                  fill={color}
                />
                <path
                  d="M45.302793,10.3803891 L45.302793,2.29347556 L46.586852,2.29347556 L46.586852,3.58248296 C47.2549895,2.74526815 48.2142752,2.10890272 49.3445963,2.10890272 L49.3445963,3.39822617 C49.1908584,3.38163358 49.0358273,3.36488296 48.8479793,3.36488296 C48.0430781,3.36488296 46.9638413,4.0012484 46.586852,4.65420642 L46.586852,10.3803891 L45.302793,10.3803891 Z"
                  fill={color}
                />
                <path
                  d="M50.251068,9.30863407 L50.9020696,8.40457481 C51.450256,9.02387358 52.4944127,9.55941926 53.6257038,9.55941926 C54.8927887,9.55941926 55.5953596,8.97362173 55.5953596,8.17006617 C55.5953596,6.21135012 50.4736727,7.41692049 50.4736727,4.4198242 C50.4736727,3.14725136 51.5698838,2.09243654 53.5398628,2.09243654 C54.9613322,2.09243654 55.954243,2.6112316 56.6050829,3.2646637 L56.0058123,4.13537975 C55.5093569,3.54926617 54.6187763,3.11375012 53.5398628,3.11375012 C52.4095417,3.11375012 51.7069708,3.66604642 51.7069708,4.38632296 C51.7069708,6.14450568 56.828011,4.98902914 56.828011,8.13656494 C56.828011,9.49289086 55.7153107,10.5813649 53.5909471,10.5813649 C52.2207237,10.5813649 51.0905642,10.1625995 50.251068,9.30863407"
                  fill={color}
                />
                <mask id="mask-2" fill="white">
                  <use href="url(#path-1)" />
                </mask>
                <polygon
                  fill={color}
                  mask="url(#mask-2)"
                  points="58.9165347 10.3803575 60.2009171 10.3803575 60.2009171 2.29344395 58.9165347 2.29344395"
                />
                <path
                  d="M69.1241494,6.32808296 C69.1241494,4.68747062 68.1472429,3.21452247 66.383541,3.21452247 C64.6195157,3.21452247 63.6432558,4.68747062 63.6432558,6.32808296 C63.6432558,7.98623605 64.6195157,9.4591842 66.383541,9.4591842 C68.1472429,9.4591842 69.1241494,7.98623605 69.1241494,6.32808296 M62.2900066,6.32808296 C62.2900066,3.98426074 63.8661839,2.09238914 66.383541,2.09238914 C68.9012214,2.09238914 70.4770753,3.98426074 70.4770753,6.32808296 C70.4770753,8.67222123 68.9012214,10.5813175 66.383541,10.5813175 C63.8661839,10.5813175 62.2900066,8.67222123 62.2900066,6.32808296"
                  fill={color}
                  mask="url(#mask-2)"
                />
                <path
                  d="M6.48405362,7.60354765 C5.76838833,7.60354765 5.18609188,8.17038222 5.18609188,8.87311802 C5.18609188,9.56937481 5.76838833,10.1363674 6.48405362,10.1363674 C7.20020389,10.1363674 7.78007545,9.56937481 7.78007545,8.87311802 C7.78007545,8.17038222 7.20020389,7.60354765 6.48405362,7.60354765"
                  fill={color}
                  mask="url(#mask-2)"
                />
                <path
                  d="M6.48405362,2.5337837 C5.76838833,2.5337837 5.18609188,3.10330469 5.18609188,3.80003556 C5.18609188,4.50229728 5.76838833,5.06691951 6.48405362,5.06691951 C7.20020389,5.06691951 7.78007545,4.50229728 7.78007545,3.80003556 C7.78007545,3.10330469 7.20020389,2.5337837 6.48405362,2.5337837"
                  fill={color}
                  mask="url(#mask-2)"
                />
                <path
                  d="M11.6702587,5.0668879 C10.9539467,5.0668879 10.3729436,5.63609284 10.3729436,6.33819654 C10.3729436,7.03650765 10.9539467,7.60350025 11.6702587,7.60350025 C12.3847923,7.60350025 12.9646639,7.03650765 12.9646639,6.33819654 C12.9646639,5.63609284 12.3847923,5.0668879 11.6702587,5.0668879"
                  fill={color}
                  mask="url(#mask-2)"
                />
                <path
                  d="M1.29611882,10.1364148 C0.579968555,10.1364148 -6.46636813e-05,10.7100444 -6.46636813e-05,11.4059852 C-6.46636813e-05,12.1068247 0.579968555,12.6731852 1.29611882,12.6731852 C2.0134007,12.6731852 2.59488886,12.1068247 2.59488886,11.4059852 C2.59488886,10.7100444 2.0134007,10.1364148 1.29611882,10.1364148"
                  fill={color}
                  mask="url(#mask-2)"
                />
                <path
                  d="M1.29611882,0 C0.579968555,0 -6.46636813e-05,0.569520988 -6.46636813e-05,1.26640988 L-6.46636813e-05,6.33821235 C-6.46636813e-05,7.03652346 0.579968555,7.60351605 1.29611882,7.60351605 C2.0134007,7.60351605 2.59488886,7.03652346 2.59488886,6.33821235 L2.59488886,1.26640988 C2.59488886,0.569520988 2.0134007,0 1.29611882,0"
                  fill={color}
                  mask="url(#mask-2)"
                />
              </g>
              <use
                stroke="#7E7E7E"
                mask="url(#mask-4)"
                strokeWidth="2.4"
                href="url(#path-3)"
              />
            </g>
          </g>
        </g>
      </svg>
    );
  }
}

export default Gift;



// WEBPACK FOOTER //
// ./src/js/Cio/Assets/PoweredBy.js